<div class="arm-component">
  <ac-nav-auto>
    <img src="./assets/logo.svg" class="arm-logo" logo/>
    <div menu class="header-toolbar">
      <header-toolbar></header-toolbar>
    </div>
  </ac-nav-auto>

  <div class="arm-container">
    <router-outlet></router-outlet>
  </div>
</div>
